export { default as COOKIES } from './cookies';

export const MAX_PAGE_SIZE_DEFAULT = 24;

export const SHIPPING_EXCLUDED_STATES = ['AK', 'HI'];

export const LOW_RESULTS_THRESHOLD = 16;

export const LOW_RESULTS_COUNT = 12;

export const SELL_MY_CAR_URL = '/sell-my-car';

export const MIN_MONTHLY_PAYMENT = 50;
